import { z } from 'zod';
export const patientConsentValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        agencyName: z.string(),
        agencyShortName: z.string(),
        agencyAddress: z.string(),
        agencyAdministrator: z.string(),
        agencyAdministratorPhone: z.string(),
        agencyAdministratorFax: z.string().nullish(),
        agencyHoursMonday: z.string().nullish(),
        agencyHoursTuesday: z.string().nullish(),
        agencyHoursWednesday: z.string().nullish(),
        agencyHoursThursday: z.string().nullish(),
        agencyHoursFriday: z.string().nullish(),
        agencyHoursSaturday: z.string().nullish(),
        agencyHoursSunday: z.string().nullish(),
        agencyChargeSN: z.string(),
        agencyChargePT: z.string(),
        agencyChargeOT: z.string(),
        agencyChargeST: z.string(),
        agencyChargeHHA: z.string(),
        agencyChargeMSW: z.string(),
        hotlineName: z.string(),
        hotlinePhone: z.string(),
        hotlineAddress: z.string(),
        language: z.string({ message: 'Language is required' }),
        informationNotRelease: z.string().optional(),
        informationNotReleaseTo: z.string().optional(),
        advanceDirectiveCompleted: z.string({ message: 'Please select an option' }),
        powerOfAttorney: z.string({ message: 'Please select an option' }),
        livingWill: z.string({ message: 'Please select an option' }),
        dnr: z.string({ message: 'Please select an option' }),
        otherAdvanceDirective: z.string().optional(),
        advanceDirectiveChecklist: z.array(z.string()).min(1, 'requires at least one'),
        photographConsent: z.string({ message: 'Please select an option' }),
        proposedServices: z.array(z.string()).min(1),
        patientSigned: z.literal(true),
    }),
});
